export default __webpack_public_path__ + "static/media/finance.7cb3db1c.png";